export default __webpack_public_path__ + "static/media/6osizp.03c6a25c.webp";